import React from 'react'

export const headerCell = value => {
  return (
    <div key={value} className='cell df aic'>
      <span>{value}</span>
    </div>
  )
}

export const initStructure = {
  headers: [
    {
      value: 'Grower',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Ticket Number',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Ticket Date',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Bill of Landing',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Gross Lbs',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Net Lbs',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Tare Lbs',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'T.W.',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'MST',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'DMG',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'F.M.',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'RVA',
      format() {
        return headerCell(this.value)
      }
    }
  ]
}

export const initCompanyTrainingStructure = {
  headers: [
    {
      value: 'Company SAP ID',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Company Name',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Contact Name',
      format() {
        return headerCell(this.value)
      }
    },
    {
      value: 'Contact E-mail',
      format() {
        return headerCell(this.value)
      }
    }
  ]
}